import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment";
import { useForm, } from "react-hook-form";
import CardLayout from '../../../components/utils/CardLayout';
import SearchBar from '../../../components/utils/SearchBar';
import "react-datepicker/dist/react-datepicker.css";
import Table from '../../../components/utils/Table';
import Calendar2LineIcon from 'remixicon-react/Calendar2LineIcon';
import Button from '../../../components/utils/Button';
import DatePicker from "react-datepicker";
import Modal from '../../../components/utils/Model'
import repushActivationActions from '../../../redux/repushActivation/actions'
import { convertDateTimeToRequiredFormatTZ, isAdminAgent, isAdmin } from '../../../helpers/commonFunction';
import Alert from '../../../components/utils/Alert'
import useSocket from '../../../hooks/useSocket'


const { getPrepaidIQActivationforRepush, updatePrePaidIQActivationForRepush, resetMessage } = repushActivationActions;

const PrepaidIQActivation = () => {
    const dispatch = useDispatch();
    const { tokenData } = useSelector((state) => state.auth);
    const { prepaidIQActivatioList, prepaidIQsearchButtonLoading, prepaidIQActivatioListLoading, prepaidIqButtonLoading, updatePrePaidiQActivationMessage, updatePrePaidIQActivationError } = useSelector((state) => state.repushActivation);
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');
    const [filterText, setFilterText] = useState("");
    const [toDate, setToDate] = useState(new Date())
    const [showTable, setShowTable] = useState(false);
    const [fromDate, setFromDate] = useState(new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000));
    const [searchData, setSearchData] = useState({
        fromDate: moment(fromDate).format("YYYY-MM-DD"),
        toDate: moment(toDate).format("YYYY-MM-DD"),
    });
    const datePickerRef = useRef(null);
    const datePickerRef2 = useRef(null);
    const openDatePicker = () => {
        datePickerRef.current.setOpen(true);
    };
    const openDatePicker2 = () => {
        datePickerRef2.current.setOpen(true);
    };
    const handleFilterChange = (value) => {
        setFilterText(value);
    };
    const [selectedRows, setSelectedRows] = useState([]);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const { register: registerFilter, handleSubmit: handleSubmit, formState: { errors: filterError }, watch, reset } = useForm({ defaultValues: searchData });

    useSocket('repush prepaidIQ activation request', () => {
        if (isAdmin(tokenData) || isAdminAgent(tokenData)) {
            dispatch(getPrepaidIQActivationforRepush(searchData));
        }
    });

    useEffect(() => {
        dispatch(resetMessage());
    }, [updatePrePaidiQActivationMessage, updatePrePaidIQActivationError])

    useEffect(() => {
        if (updatePrePaidiQActivationMessage !== null && updatePrePaidiQActivationMessage !== undefined) {
            displayAlert(updatePrePaidiQActivationMessage, 'alert-success');
            reset();
            setSelectedRows([]);
        }
        if (updatePrePaidIQActivationError !== null && updatePrePaidIQActivationError !== undefined) {
            displayAlert(updatePrePaidIQActivationError, 'alert-danger');
            reset();
        }
    }, [updatePrePaidiQActivationMessage, updatePrePaidIQActivationError]);


    const displayAlert = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
    };

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
        dispatch(resetMessage());
    }

    const onSubmit = (data) => {
        const newData = {
            ...data,
            toDate: moment(new Date(toDate)).format("YYYY-MM-DD"),
            fromDate: moment(new Date(fromDate)).format("YYYY-MM-DD"),
        };
        setShowTable(true);
        setSearchData(newData)
        setSelectedRows([]);
        dispatch(getPrepaidIQActivationforRepush(newData));
    }

    const filteredItems = Array.isArray(prepaidIQActivatioList) && prepaidIQActivatioList.length > 0 ? prepaidIQActivatioList.filter(item => {
        if (typeof filterText !== 'string' || typeof item !== 'object') return false;
        return Object.values(item).some(value => typeof value === 'string' && value.toLowerCase().includes(filterText.toLowerCase()));
    }) : [];

    const dataSource = filteredItems && filteredItems.length > 0 && filteredItems.map((activation, key) => {
        return {
            key: key + 1,
            activationId: activation.ActivationID,
            transactionId: activation.TransactionID,
            serialNumber: activation.SerialNumber,
            remark: activation.Remark,
            dealerName: activation.DealerName,
            requestedDtTm: activation.RequestedDtTm !== null ? convertDateTimeToRequiredFormatTZ(activation.RequestedDtTm) : '',
            simType: activation.SimTypeValue,
            checkbox: (
                <input
                    type="checkbox"
                    checked={selectedRows.includes(activation.ActivationID)}
                    onChange={() => handleRowSelect(activation.ActivationID)}
                />
            ),
        }
    });

    const isAllSelected = dataSource.length > 0 && selectedRows.length === dataSource.length;

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(filteredItems.map(row => row.ActivationID));
        } else {
            setSelectedRows([]);
        }
    };

    const handleRowSelect = (activationId) => {
        setSelectedRows(prev => {
            if (prev.includes(activationId)) {
                return prev.filter(id => id !== activationId);
            } else {
                return [...prev, activationId];
            }
        });
    };

    const columns = [
        { displayName: '#', key: 'key' },
        { displayName: <input type="checkbox" checked={isAllSelected} onChange={handleSelectAll} />, key: 'checkbox' },
        { displayName: 'TRANSACTION ID', key: 'transactionId' },
        { displayName: 'SERIAL/EID', key: 'serialNumber' },
        { displayName: 'DEALER NAME', key: 'dealerName' },
        { displayName: 'DATE', key: 'requestedDtTm' },
        { displayName: 'SIM TYPE', key: 'simType' },
        { displayName: 'REMARK', key: 'remark' },
    ];

    const handleRepushClick = () => {
        if (selectedRows.length > 0) {
            setShowConfirmModal(true);
        }
    };

    const handleConfirmSubmit = () => {
        if (selectedRows.length === 0) return;
        const newdata = {
            selectedRequests: selectedRows.join(","),
        };
        dispatch(updatePrePaidIQActivationForRepush(newdata, searchData));
        setShowConfirmModal(false);
    };

    return (
        <>
            {showAlert && <Alert type={alertType} text={alertText} closeBtn={alertCancel} />}
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-row">
                    <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                        <label>From Date</label>
                        <Calendar2LineIcon onClick={openDatePicker} size={'1.5rem'} style={{ cursor: 'pointer', position: 'absolute', 'top': '36px', right: '12px', zIndex: 1 }} />
                        <DatePicker
                            ref={datePickerRef}
                            selected={fromDate}
                            className="form-control"
                            onChange={(date) => setFromDate(date)}
                            dateFormat="yyyy-MM-dd"
                            name="fromDate"
                            showMonthDropdown
                            showYearDropdown
                            onKeyDown={(e) => {
                                e.preventDefault();
                            }}
                            value={fromDate}
                        />
                    </div>

                    <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                        <label>To Date</label>
                        <Calendar2LineIcon onClick={openDatePicker2} size={'1.5rem'} style={{ cursor: 'pointer', position: 'absolute', 'top': '36px', right: '12px', zIndex: 1 }} />
                        <DatePicker
                            ref={datePickerRef2}
                            selected={toDate}
                            className="form-control center"
                            onChange={(date) => setToDate(date)}
                            dateFormat="yyyy-MM-dd"
                            name="todate"
                            showMonthDropdown
                            showYearDropdown
                            onKeyDown={(e) => {
                                e.preventDefault();
                            }}
                            value={toDate}
                        />
                    </div>

                    <div className={'col-lg-2 col-md-4'}>
                        <div className={"mt-2 d-flex justify-content-start activation-search-btn"}>
                            <Button title="Search" style="minWidth:80px" loading={prepaidIQsearchButtonLoading} buttonClass={`btn btn-primary mt-1 btn-md Activity_searchBtn__GlBtC`} buttonType='submit' />
                        </div>
                    </div>

                </div>
            </form>

            {showTable && (
                <>
                    <hr />
                    <div className="row align-items-baseline">
                        <div className="col-lg-3 col-md-6 od-2">
                            <SearchBar onFilter={handleFilterChange} filterText={filterText} />
                        </div>
                    </div>

                    <Table columns={columns} loading={prepaidIQActivatioListLoading} data={dataSource} pagination={false} />

                    {selectedRows.length > 0 && (
                        <div className="d-flex justify-content-end mt-3">
                            <Button title="Repush Request" style="minWidth:150px" buttonClass="btn btn-primary btn-md" onClick={handleRepushClick} />
                        </div>
                    )}
                </>
            )}

            <Modal
                showModal={showConfirmModal}
                title="Are you Sure"
                onHide={() => setShowConfirmModal(false)}
                width={400}
                showFooter={false}
                alignment="modal-dialog-centered"
            >
                <p>
                    You want to repush this activations<strong></strong>?
                </p>
                <div className="text-right">
                    <button className="btn btn-secondary mr-2" onClick={() => setShowConfirmModal(false)}>No</button>
                    <Button title="Yes" style="minWidth:80px" loading={prepaidIqButtonLoading} buttonClass="btn btn-primary" onClick={handleConfirmSubmit} />
                </div>
            </Modal>
        </>
    )
}

export default PrepaidIQActivation